import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { CustomDateFilterValue } from '../../components/DateFilter/DateFilter';
import {
  changeDateFilter,
  changeLimitFilter,
  changeTableSizeFilter,
} from '../../containers/StatPage/actions';
import {
  selectCustomDateFilterValue,
  selectDateFilterValue,
  selectLimitFilterValue,
  selectTableSizeFilterValue,
} from '../../containers/StatPage/selectors';

import V2FilterBar from './V2FilterBar';

const V2GlobalFilters: React.FC = () => {
  const dispatch = useDispatch();

  const tableSizeFilterValue = useSelector(selectTableSizeFilterValue);
  const limitFilterValue = useSelector(selectLimitFilterValue);
  const dateFilterValue = useSelector(selectDateFilterValue);
  const customDateFilterValue = useSelector(selectCustomDateFilterValue);

  const handleChangeTableSizeFilter = React.useCallback(
    (value?: number) => {
      dispatch(changeTableSizeFilter(value));
    },
    [dispatch],
  );

  const handleChangeLimitFilter = React.useCallback(
    (value: number) => {
      dispatch(changeLimitFilter(value));
    },
    [dispatch],
  );

  const handleChangeDateFilter = React.useCallback(
    (value?: number, customValue?: CustomDateFilterValue) => {
      dispatch(changeDateFilter({ value, customValue }));
    },
    [dispatch],
  );

  return (
    <V2FilterBar
      tableSizeId={tableSizeFilterValue}
      limitId={limitFilterValue}
      dateId={dateFilterValue}
      customDate={customDateFilterValue}
      onTableSizeChange={handleChangeTableSizeFilter}
      onLimitChange={handleChangeLimitFilter}
      onDateChange={handleChangeDateFilter}
    />
  );
};

export default V2GlobalFilters;
